/* eslint-disable no-new */
import Vue from 'vue';
import '../general/utils/airbrake'
import throttle from 'lodash.throttle';
import '../qmusic/polyfill';
import loader from '../general/utils/loader';
import PlayButton from '../general/components/playButton/PlayButton';
import ChannelList from '../general/components/channelList/ChannelList';
import ChannelButton from '../general/components/channelList/ChannelButton';
import ChannelBlock from "../general/components/channelBlock/ChannelBlock";
import LiveProgram from '../general/components/liveProgram/LiveProgram';
import ProgramList from '../general/components/program/ProgramList';
import ProgramLive from '../general/components/program/ProgramLive';
import Playlist from '../general/components/playlist/Playlist';
import Hitlist from '../general/components/hitlist/Hitlist';
import NavPlayer from '../general/components/navPlayer/NavPlayer';
import store from '../general/store';
import authentication from '../general/authentication'
import screenObserverInit from '../general/utils/screenObserver';
import OptInBox from '../general/components/newsletter/OptInBox.vue'

import gridInit from '../qmusic/grid';
import adsInit from '../qmusic/ads';
import contentInit from '../general/utils/contentMedia'
import {init as formsInit} from '../general/components/webform/forms'

import SvgIcon from '../general/components/SvgIcon'

import generalFilters from '../general/filters'

import eventBus from '../general/api/eventBus';
import { PLAYER_POPUP_READY, STOP_CHANNEL, postMessageToOpener } from '../general/PlayerMessaging';
import siteMenu from '../qmusic/menu';
import ProfileForm from '../profile/ProfileForm'

import VueFormulate from '@braid/vue-formulate'
import { nl } from '@braid/vue-formulate-i18n'

Vue.use(VueFormulate,  {
  plugins: [ nl ],
  locale: 'nl'
})
import ready from '../general/utils/ready'

authentication.install(Vue, store)
authentication.onLogin(() => {
  if(!window.nativeAppOpen){
    store.dispatch('likes/fetch')
  }

  ready(() => {
    document.querySelectorAll('[data-auth-hide]').forEach(el => el.classList.add('hidden'))
    document.querySelectorAll('[data-auth-show]').forEach(el => el.classList.remove('hidden'))
  })
})

gridInit()
adsInit()
screenObserverInit()
contentInit()
formsInit(store)

let trustOrigin;
try { trustOrigin = window.opener ? window.opener.location.origin : null } catch (error) { trustOrigin = null }
const receiveMessage = (event) => {
  if (event.origin !== trustOrigin) { return; }
  if (event.data && event.data.action) {
    const { data: { action, value } } = event;
    eventBus.$emit(action, value);
  }
};

// General use
Vue.use(generalFilters)

// General components
Vue.component('SvgIcon', SvgIcon)

// listen to messages from source window
window.addEventListener('message', receiveMessage, false);

// notify source window
postMessageToOpener({ action: PLAYER_POPUP_READY, value: 'true' });

// fetch channels list
store.dispatch('channels/fetch');

// get program updates
store.dispatch('program/subscribeOnChange');

// get mgp updates
store.dispatch('mgp/subscribeOnChange');
// store.dispatch('mgp/subscribeOnChange', { station: 'qbe_maximum_hits' });

// fetch/clear liked tracks after login / logout

const run = () => {
  // Should be a list of all imported vue components
  const dataComponents = {
    ChannelList,
    ChannelButton,
    LiveProgram,
    ProgramList,
    ProgramLive,
    Playlist,
    NavPlayer,
    Hitlist,
    PlayButton,
    ChannelBlock,
    ProfileForm,
    OptInBox
  };
  // Create Vue app for elements with [data-component]
  loader(dataComponents, store);
};

window.addEventListener('storage', () => {
  const { radioplayer } = store.state;

  const buffering = localStorage.getItem('buffering') === 'STREAM_BUFFERING';
  if (buffering !== radioplayer.buffering) {
    store.dispatch('radioplayer/buffering', buffering);
  }

  const activeChannel = localStorage.getItem('channel');
  if (activeChannel !== radioplayer.activeChannel) {
    store.dispatch('radioplayer/activeChannel', activeChannel);
  }
  const lastChannel = localStorage.getItem('lastChannel');
  if (lastChannel !== radioplayer.lastChannel) {
    store.dispatch('radioplayer/lastChannel', lastChannel);
  }
});

// Bootstrap vue apps
document.addEventListener('DOMContentLoaded', run);
if (window.jQuery) {
  window.jQuery(document).on('content:load', run);
}

//
document.addEventListener('DOMContentLoaded', () => {
  siteMenu();
});

// Notify main window to stop active channel
const onClosePlayer = () => {
  postMessageToOpener({ action: STOP_CHANNEL });
};
window.addEventListener('beforeunload', onClosePlayer);

// Toggle nav player
function toggleNavPlayer() {
  const elm = document.querySelector('[component="ChannelList"]');
  store.dispatch('radioplayer/showNavPlayer', !elm || (elm && elm.getBoundingClientRect().bottom < 0));
}
const throttleToggleNavPlayer = throttle(toggleNavPlayer, 250);
window.addEventListener('scroll', throttleToggleNavPlayer);
window.jQuery(document).on('content:load', toggleNavPlayer);

// Toggle footer class
function toggleFooterClass() {
  const elm = document.querySelector('.o-page__footer');
  if (!elm) { return; }
  const bbox = elm.getBoundingClientRect();
  const height = window.innerHeight || document.documentElement.clientHeight;
  const cls = 'c-footer--is-visible';
  if (bbox.top < height) {
    if (elm.classList.contains(cls)) { return; }
    elm.classList.add(cls);
  } else {
    if (!elm.classList.contains(cls)) { return; }
    elm.classList.remove(cls);
  }
}
window.addEventListener('scroll', toggleFooterClass);
window.jQuery(document).on('content:load', toggleFooterClass);

// Update body theme class
window.addEventListener('locationChange', () => {
  store.dispatch('program/setTheme');
});

window.updated = 'attempt-1'
